import type { ValueOf } from 'type-fest';
import type { ProfileType, PropertyCountRangeType } from '@zg-rentals/ts-rental-manager-api-client';

export const STEPS = {
  NAME: 'NAME',
  PROFILE_TYPE: 'PROFILE_TYPE',
  PROPERTY_COUNT: 'PROPERTY_COUNT',
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  PROPERTY_CONFIRMATION: 'PROPERTY_CONFIRMATION',
  MULTIPLEX_UNIT_ENTRY: 'MULTIPLEX_UNIT_ENTRY',
  MULTIPLEX_UNITS_ADDED: 'MULTIPLEX_UNITS_ADDED',
  THANKS: 'THANKS',
} as const;

export type StepType = ValueOf<typeof STEPS>;

export type UserProfile = {
  firstName: string;
  lastName: string;
  profileType: ProfileType | null;
  propertyCountRange: PropertyCountRangeType | null;
};
